import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import { useParams } from 'react-router-dom'

import { useAdditionalActionsMatchQuery } from '../../../graphql'
import useLoggedInUserType from '../hooks/use-logged-in-user-type'
import { VALID_BALLSPORT_MATCH_STATES } from '../Match.constants'
import { UserType } from '../Match.types'

import CancelMatch from './CancelMatch'
import MobileAdditionalActions from './MobileAdditionalActions'
import OpenInGoogleMaps from './OpenInGoogleMaps'
import SaveMatchToCalendar from './SaveMatchToCalendar'
import ShareMatch from './ShareMatch'

const AdditionalActions = () => {
  const { userType } = useLoggedInUserType()
  const { id } = useParams<{ id: string }>()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { data } = useAdditionalActionsMatchQuery({ variables: { matchId: id } })

  if (!data) {
    return null
  }

  if (VALID_BALLSPORT_MATCH_STATES.includes(data.match.state)) {
    return isMobile ? (
      <MobileAdditionalActions />
    ) : (
      <Box width="fit-content">
        <Stack direction="row" flexWrap="wrap" justifyContent="flex-end" width="100%" gap={4}>
          <SaveMatchToCalendar />
          <OpenInGoogleMaps />
          {userType === UserType.ORGANIZER ? <CancelMatch /> : <ShareMatch />}
        </Stack>
      </Box>
    )
  }

  return null
}

export default AdditionalActions
